module.exports = __webpack_public_path__ + "static/media/zp-logo.45acd50d.svg";